import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { GqlPlannerV2VisitPossibleDaysStatus } from "~/__generated__";
import { VISIT_STATUS_TO_COLOR_FOREGROUND_MAP, VISIT_STATUS_TO_COLOR_MAP } from "~/config/statusColors";

type TimelineStatusMarkerProps = {
    status: GqlPlannerV2VisitPossibleDaysStatus;
    markerDayIndex: number;
    markerPositionPercent: number;
    variant: "full" | "minimal";
};

export function TimelineStatusMarker({ status, markerDayIndex, markerPositionPercent, variant }: TimelineStatusMarkerProps) {
    const { t } = useTranslation("plannerV2");

    return (
        <Stack
            sx={{
                gridColumn: markerDayIndex + 1,
                gridRow: 1,
                paddingBottom: 0.5,
            }}
        >
            {variant === "full" && (
                <Typography
                    variant="caption"
                    sx={{
                        padding: 1,
                        textAlign: "center",
                        backgroundColor: VISIT_STATUS_TO_COLOR_MAP[status],
                        color: VISIT_STATUS_TO_COLOR_FOREGROUND_MAP[status],
                        borderRadius: "4px",
                        textWrap: "nowrap",
                        width: "fit-content",

                        position: "relative",
                        left: "50%",
                        // Some wild CSS to prevent the marker from overflowing
                        // We keep it centered to the arrow, and snap it to the edges
                        "--marker-position": `${markerPositionPercent} * 1cqw`,
                        "--marker-half-width": "50%",
                        // Extra padding to prevent arrow sticking out on left
                        "--left-edge-padding": "-8px",
                        "--right-edge-padding": "-8px",
                        transform: `translateX(
                            calc(
                                clamp(
                                    calc(var(--marker-half-width) + var(--left-edge-padding)),
                                    var(--marker-position),
                                    calc(100cqw - var(--marker-half-width) - var(--right-edge-padding))
                                )
                                - var(--marker-position)
                                - var(--marker-half-width)
                            )
                        )`,
                    }}
                >
                    {t(`plannerStatus.${status}`)}
                </Typography>
            )}
            <Box
                component="span"
                sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "6px solid transparent",
                    borderRight: "6px solid transparent",
                    borderTop: "8px solid",
                    borderTopColor: VISIT_STATUS_TO_COLOR_MAP[status],
                    position: "relative",
                    left: "50%",
                    transform: "translateX(-50%)",
                }}
            />
        </Stack>
    );
}
